import React, {useEffect, useState} from "react";
import {toast, ToastContainer} from "react-toastify";
import SideBar from "../../../../common/SideBar";
import NavBar from "../../../../common/NavBar";
import {Link} from "react-router-dom";
import {makeStyles} from '@material-ui/core/styles';
import clsx from 'clsx';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Spinner from "reactjs-simple-spinner";
import TextField from "@material-ui/core/TextField";
import SettingsService from "../../../../services/SettingsService";

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        backgroundColor: '#ffffff',
        padding: "2%"
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
    icon: {
        verticalAlign: 'bottom',
        height: 20,
        width: 20,
    },
    details: {
        alignItems: 'center',
    },
    column: {
        flexBasis: '33.33%',
    },
    smallColumn: {
        flexBasis: '20.00%',
        margin: 2
    },
    bigColumn: {
        flexBasis: '60.00%',
    },
    helper: {
        borderLeft: `2px solid ${theme.palette.divider}`,
        padding: theme.spacing(1, 2),
    },
    link: {
        color: theme.palette.primary.main,
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
}));

const Index = (props) => {


    const classes = useStyles();
    const [loading, setLoading] = useState(true);
    const [updateLoading, setUpdateLoading] = useState(false);

    const [settings, setSettings] = useState({});

    useEffect(() => {
        setLoading(true);
        setUpdateLoading(false);
        SettingsService.getSettings()
            .then(res => {
                console.log(res)
                if (res === undefined) {
                    setSettings({})
                    setLoading(false)
                }
                setSettings(res.data.data[0]);
                setLoading(false);
            })
            .catch(err => {
                console.error(err);
                setSettings([])
                setLoading(false)
            })
    }, []);

    const updateSettings = () => {
        setUpdateLoading(true);

        console.log(settings);


        console.log("request payload: ", settings);

        SettingsService.updateSettings(settings).then(res => {
            console.log("res: ", res)
            if (res.status === 200) {
                SettingsService.getSettings().then(response => {
                    console.log(response);
                    if (response === undefined) {
                        toast.warning('✅ Commissions Rates Updated, 🚫 Failed to get new data ', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                        setUpdateLoading(false);
                    }
                    setSettings(response.data.data[0]);
                    toast('✅ Commissions Rates Updated ', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    setUpdateLoading(false);

                    //   console.log();                                                                                        );
                }).catch(err => {
                    console.log(err);
                    setSettings({})
                    toast.warning('✅ Commissions Rates Updated, 🚫 Failed to get new data ', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    setUpdateLoading(false);
                });

            } else {
                toast.warning('🚫 Failed to update commission rates: ' + res.response.data.message, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                setUpdateLoading(false);
            }
        })
            .catch((err) => {
                console.log("error: ", err)
                toast.warning('🚫 Failed to update commission rates: ' + err.response.data.message, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                setUpdateLoading(false);
            })

    }

    return (
        <>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            {/* Same as */}
            <ToastContainer/>

            <SideBar roles={JSON.parse(localStorage.getItem('roles'))}/>
            <div
                id="main-content"
                className="main-panel ps-container ps-theme-default">
              <NavBar roles={JSON.parse(localStorage.getItem('roles'))}/>

                <div className="content">
                    <div className="container-fluid">
                        <ul className="breadcrumb">
                            <Link to="/dashboard"><a href><i className="fa fa-home"/>&nbsp;Dashboard</a> </Link>
                             &nbsp;|&nbsp;
                            <Link to="/settings"><a href><i className="fa fa-cog"/>&nbsp;Settings</a></Link>
                             &nbsp;|&nbsp;
                            <span className="upper-class">Commissions Rates</span>
                        </ul>
                        <div className="row mt">
                            <div className="col-lg-12">
                                <div className="content-panel">
                                    {loading && (
                                        <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                                            <Spinner
                                                size="large"
                                                message="Please wait....."
                                                line-fg-color="#64c3c2"
                                            />
                                        </div>
                                    )}
                                    {updateLoading && (
                                        <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                                            <Spinner
                                                size="large"
                                                message="Updating Commissions Rates,Please wait....."
                                                line-fg-color="#64c3c2"
                                            />
                                        </div>
                                    )}

                                    {!loading && !updateLoading && (
                                        <>
                                            <div className="row mb-5">
                                                <div className="col-md-3"/>
                                                <div className="col-md-3"/>
                                            </div>
                                            <div className={classes.root}>
                                                <h4 className="title h4">Commission Rates</h4>
                                                <Accordion>
                                                    <AccordionSummary
                                                        expandIcon={<ExpandMoreIcon/>}
                                                        aria-controls="panel1c-content"
                                                        id="panel1c-header"
                                                    >
                                                        <div className={classes.bigColumn}>
                                                            <Typography
                                                                className={classes.heading}>Accident Tied</Typography>
                                                        </div>
                                                    
                                                        <div className={classes.smallColumn}>
                                                            <Typography
                                                                className={classes.secondaryHeading}>Manage</Typography>
                                                        </div>
                                                    </AccordionSummary>
                                                    <AccordionDetails className={classes.details}>
                                                     
                                                        <div className={classes.bigColumn}>

                                                            <TextField
                                                                className="mb-3 mr-2"
                                                                margin="dense"
                                                                label="Year 1"
                                                                type="number"
                                                                value={settings.accident_year1_tied_agent_rate}
                                                                onChange={(e) => {
                                                                    setSettings((prevSettings) => ({
                                                                        ...prevSettings,
                                                                        accident_year1_tied_agent_rate: parseFloat(e.target.value)
                                                                    }))
                                                                }
                                                                }
                                                            />
                                                            <TextField
                                                                className="mb-3 mr-2"
                                                                margin="dense"
                                                                label="Year 2"
                                                                type="number"
                                                                value={settings.accident_year2_tied_agent_rate}
                                                                 onChange={(e) => {
                                                                     setSettings((prevSettings) => ({
                                                                         ...prevSettings,
                                                                         accident_year2_tied_agent_rate: parseFloat(e.target.value)
                                                                     }))
                                                                    }
                                                                 }
                                                            />
                                                            <TextField
                                                                className="mb-3 mr-2"
                                                                margin="dense"
                                                                label="Year 3"
                                                                type="number"
                                                                value={settings.accident_year3_tied_agent_rate}
                                                                onChange={(e) => {
                                                                    setSettings((prevSettings) => ({
                                                                        ...prevSettings,
                                                                        accident_year3_tied_agent_rate: parseFloat(e.target.value)
                                                                    }))
                                                                }
                                                                }
                                                            />
                                                            <TextField
                                                                className="mb-3 mr-2"
                                                                margin="dense"
                                                                label="Year 4"
                                                                type="number"
                                                                value={settings.accident_year4_tied_agent_rate}
                                                                onChange={(e) => {
                                                                    setSettings((prevSettings) => ({
                                                                        ...prevSettings,
                                                                        accident_year4_tied_agent_rate: parseFloat(e.target.value)
                                                                    }))
                                                                }
                                                                }
                                                            />
                                                            <TextField
                                                                className="mb-3"
                                                                margin="dense"
                                                                label="Year 5"
                                                                type="number"
                                                                value={settings.accident_year5_tied_agent_rate}
                                                                onChange={(e) => {
                                                                    setSettings((prevSettings) => ({
                                                                        ...prevSettings,
                                                                        accident_year5_tied_agent_rate: parseFloat(e.target.value)
                                                                    }))
                                                                }
                                                                }
                                                            />
                                                        </div>
                                                        <div className={clsx(classes.smallColumn, classes.helper)}>
                                                            <Button
                                                                onClick={updateSettings}
                                                                className="btn btn-round btn-primary">
                                                                &nbsp;Update Rates&nbsp;
                                                                <i className="fa fa-check-double"/>
                                                            </Button>
                                                        </div>
                                                    </AccordionDetails>
                                                    <Divider/>

                                                </Accordion>
                                                <Accordion>
                                                    <AccordionSummary
                                                        expandIcon={<ExpandMoreIcon/>}
                                                        aria-controls="panel1c-content"
                                                        id="panel1c-header"
                                                    >
                                                        <div className={classes.bigColumn}>
                                                            <Typography
                                                                className={classes.heading}>Accident
                                                                Executive</Typography>
                                                        </div>

                                                        <div className={classes.smallColumn}>
                                                            <Typography
                                                                className={classes.secondaryHeading}>Manage</Typography>
                                                        </div>
                                                    </AccordionSummary>
                                                    <AccordionDetails className={classes.details}>

                                                        <div className={classes.bigColumn}>

                                                            <TextField
                                                                className="mb-3 mr-2"
                                                                margin="dense"
                                                                label="Year 1"
                                                                type="number"
                                                                value={settings.accident_year1_executive_agent_rate}
                                                                onChange={(e) => {
                                                                    setSettings((prevSettings) => ({
                                                                        ...prevSettings,
                                                                        accident_year1_executive_agent_rate: parseFloat(e.target.value)
                                                                    }))
                                                                }
                                                                }
                                                            />
                                                            <TextField
                                                                className="mb-3 mr-2"
                                                                margin="dense"
                                                                label="Year 2"
                                                                type="number"
                                                                value={settings.accident_year2_executive_agent_rate}
                                                                onChange={(e) => {
                                                                    setSettings((prevSettings) => ({
                                                                        ...prevSettings,
                                                                        accident_year2_executive_agent_rate: parseFloat(e.target.value)
                                                                    }))
                                                                }
                                                                }
                                                            />
                                                            <TextField
                                                                className="mb-3 mr-2"
                                                                margin="dense"
                                                                label="Year 3"
                                                                type="number"
                                                                value={settings.accident_year3_executive_agent_rate}
                                                                onChange={(e) => {
                                                                    setSettings((prevSettings) => ({
                                                                        ...prevSettings,
                                                                        accident_year3_executive_agent_rate: parseFloat(e.target.value)
                                                                    }))
                                                                }
                                                                }
                                                            />
                                                            <TextField
                                                                className="mb-3 mr-2"
                                                                margin="dense"
                                                                label="Year 4"
                                                                type="number"
                                                                value={settings.accident_year4_executive_agent_rate}
                                                                onChange={(e) => {
                                                                    setSettings((prevSettings) => ({
                                                                        ...prevSettings,
                                                                        accident_year4_executive_agent_rate: parseFloat(e.target.value)
                                                                    }))
                                                                }
                                                                }
                                                            />
                                                            <TextField
                                                                className="mb-3"
                                                                margin="dense"
                                                                label="Year 5"
                                                                type="number"
                                                                value={settings.accident_year5_executive_agent_rate}
                                                                onChange={(e) => {
                                                                    setSettings((prevSettings) => ({
                                                                        ...prevSettings,
                                                                        accident_year5_executive_agent_rate: parseFloat(e.target.value)
                                                                    }))
                                                                }
                                                                }
                                                            />
                                                        </div>
                                                        <div className={clsx(classes.smallColumn, classes.helper)}>
                                                            <Button
                                                                onClick={updateSettings}
                                                                className="btn btn-round btn-primary">
                                                                &nbsp;Update Rates&nbsp;
                                                                <i className="fa fa-check-double"/>
                                                            </Button>
                                                        </div>
                                                    </AccordionDetails>
                                                    <Divider/>

                                                </Accordion>
                                                <Accordion>
                                                    <AccordionSummary
                                                        expandIcon={<ExpandMoreIcon/>}
                                                        aria-controls="panel1c-content"
                                                        id="panel1c-header"
                                                    >
                                                        <div className={classes.bigColumn}>
                                                            <Typography
                                                                className={classes.heading}>Accident
                                                                Unit Leader</Typography>
                                                        </div>

                                                        <div className={classes.smallColumn}>
                                                            <Typography
                                                                className={classes.secondaryHeading}>Manage</Typography>
                                                        </div>
                                                    </AccordionSummary>
                                                    <AccordionDetails className={classes.details}>

                                                        <div className={classes.bigColumn}>

                                                            <TextField
                                                                className="mb-3 mr-2"
                                                                margin="dense"
                                                                label="Year 1"
                                                                type="number"
                                                                value={settings.accident_year1_unit_leader_agent_rate}
                                                                onChange={(e) => {
                                                                    setSettings((prevSettings) => ({
                                                                        ...prevSettings,
                                                                        accident_year1_unit_leader_agent_rate: parseFloat(e.target.value)
                                                                    }))
                                                                }
                                                                }
                                                            />
                                                            <TextField
                                                                className="mb-3 mr-2"
                                                                margin="dense"
                                                                label="Year 2"
                                                                type="number"
                                                                value={settings.accident_year2_unit_leader_agent_rate}
                                                                onChange={(e) => {
                                                                    setSettings((prevSettings) => ({
                                                                        ...prevSettings,
                                                                        accident_year2_unit_leader_agent_rate: parseFloat(e.target.value)
                                                                    }))
                                                                }
                                                                }
                                                            />
                                                            <TextField
                                                                className="mb-3 mr-2"
                                                                margin="dense"
                                                                label="Year 3"
                                                                type="number"
                                                                value={settings.accident_year3_unit_leader_agent_rate}
                                                                onChange={(e) => {
                                                                    setSettings((prevSettings) => ({
                                                                        ...prevSettings,
                                                                        accident_year3_unit_leader_agent_rate: parseFloat(e.target.value)
                                                                    }))
                                                                }
                                                                }
                                                            />
                                                            <TextField
                                                                className="mb-3 mr-2"
                                                                margin="dense"
                                                                label="Year 4"
                                                                type="number"
                                                                value={settings.accident_year4_unit_leader_agent_rate}
                                                                onChange={(e) => {
                                                                    setSettings((prevSettings) => ({
                                                                        ...prevSettings,
                                                                        accident_year4_unit_leader_agent_rate: parseFloat(e.target.value)
                                                                    }))
                                                                }
                                                                }
                                                            />
                                                            <TextField
                                                                className="mb-3"
                                                                margin="dense"
                                                                label="Year 5"
                                                                type="number"
                                                                value={settings.accident_year5_unit_leader_agent_rate}
                                                                onChange={(e) => {
                                                                    setSettings((prevSettings) => ({
                                                                        ...prevSettings,
                                                                        accident_year5_unit_leader_agent_rate: parseFloat(e.target.value)
                                                                    }))
                                                                }
                                                                }
                                                            />
                                                        </div>
                                                        <div className={clsx(classes.smallColumn, classes.helper)}>
                                                            <Button
                                                                onClick={updateSettings}
                                                                className="btn btn-round btn-primary">
                                                                &nbsp;Update Rates&nbsp;
                                                                <i className="fa fa-check-double"/>
                                                            </Button>
                                                        </div>
                                                    </AccordionDetails>
                                                    <Divider/>

                                                </Accordion>
                                                <Accordion>
                                                    <AccordionSummary
                                                        expandIcon={<ExpandMoreIcon/>}
                                                        aria-controls="panel1c-content"
                                                        id="panel1c-header"
                                                    >
                                                        <div className={classes.bigColumn}>
                                                            <Typography
                                                                className={classes.heading}>Funeral Tied</Typography>
                                                        </div>

                                                        <div className={classes.smallColumn}>
                                                            <Typography
                                                                className={classes.secondaryHeading}>Manage</Typography>
                                                        </div>
                                                    </AccordionSummary>
                                                    <AccordionDetails className={classes.details}>

                                                        <div className={classes.bigColumn}>

                                                            <TextField
                                                                className="mb-3 mr-2"
                                                                margin="dense"
                                                                label="Year 1"
                                                                type="number"
                                                                value={settings.funeral_year1_tied_agent_rate}
                                                                onChange={(e) => {
                                                                    setSettings((prevSettings) => ({
                                                                        ...prevSettings,
                                                                        funeral_year1_tied_agent_rate: parseFloat(e.target.value)
                                                                    }))
                                                                }
                                                                }
                                                            />
                                                            <TextField
                                                                className="mb-3 mr-2"
                                                                margin="dense"
                                                                label="Year 2"
                                                                type="number"
                                                                value={settings.funeral_year2_tied_agent_rate}
                                                                onChange={(e) => {
                                                                    setSettings((prevSettings) => ({
                                                                        ...prevSettings,
                                                                        funeral_year2_tied_agent_rate: parseFloat(e.target.value)
                                                                    }))
                                                                }
                                                                }
                                                            />
                                                            <TextField
                                                                className="mb-3 mr-2"
                                                                margin="dense"
                                                                label="Year 3"
                                                                type="number"
                                                                value={settings.funeral_year3_tied_agent_rate}
                                                                onChange={(e) => {
                                                                    setSettings((prevSettings) => ({
                                                                        ...prevSettings,
                                                                        funeral_year3_tied_agent_rate: parseFloat(e.target.value)
                                                                    }))
                                                                }
                                                                }
                                                            />
                                                            <TextField
                                                                className="mb-3 mr-2"
                                                                margin="dense"
                                                                label="Year 4"
                                                                type="number"
                                                                value={settings.funeral_year4_tied_agent_rate}
                                                                onChange={(e) => {
                                                                    setSettings((prevSettings) => ({
                                                                        ...prevSettings,
                                                                        funeral_year4_tied_agent_rate: parseFloat(e.target.value)
                                                                    }))
                                                                }
                                                                }
                                                            />
                                                            <TextField
                                                                className="mb-3"
                                                                margin="dense"
                                                                label="Year 5"
                                                                type="number"
                                                                value={settings.funeral_year5_tied_agent_rate}
                                                                onChange={(e) => {
                                                                    setSettings((prevSettings) => ({
                                                                        ...prevSettings,
                                                                        funeral_year5_tied_agent_rate: parseFloat(e.target.value)
                                                                    }))
                                                                }
                                                                }
                                                            />
                                                        </div>
                                                        <div className={clsx(classes.smallColumn, classes.helper)}>
                                                            <Button
                                                                onClick={updateSettings}
                                                                className="btn btn-round btn-primary">
                                                                &nbsp;Update Rates&nbsp;
                                                                <i className="fa fa-check-double"/>
                                                            </Button>
                                                        </div>
                                                    </AccordionDetails>
                                                    <Divider/>

                                                </Accordion>
                                                <Accordion>
                                                    <AccordionSummary
                                                        expandIcon={<ExpandMoreIcon/>}
                                                        aria-controls="panel1c-content"
                                                        id="panel1c-header"
                                                    >
                                                        <div className={classes.bigColumn}>
                                                            <Typography
                                                                className={classes.heading}>Funeral
                                                                Executive</Typography>
                                                        </div>

                                                        <div className={classes.smallColumn}>
                                                            <Typography
                                                                className={classes.secondaryHeading}>Manage</Typography>
                                                        </div>
                                                    </AccordionSummary>
                                                    <AccordionDetails className={classes.details}>

                                                        <div className={classes.bigColumn}>

                                                            <TextField
                                                                className="mb-3 mr-2"
                                                                margin="dense"
                                                                label="Year 1"
                                                                type="number"
                                                                value={settings.funeral_year1_executive_agent_rate}
                                                                onChange={(e) => {
                                                                    setSettings((prevSettings) => ({
                                                                        ...prevSettings,
                                                                        funeral_year1_executive_agent_rate: parseFloat(e.target.value)
                                                                    }))
                                                                }
                                                                }
                                                            />
                                                            <TextField
                                                                className="mb-3 mr-2"
                                                                margin="dense"
                                                                label="Year 2"
                                                                type="number"
                                                                value={settings.funeral_year2_executive_agent_rate}
                                                                onChange={(e) => {
                                                                    setSettings((prevSettings) => ({
                                                                        ...prevSettings,
                                                                        funeral_year2_executive_agent_rate: parseFloat(e.target.value)
                                                                    }))
                                                                }
                                                                }
                                                            />
                                                            <TextField
                                                                className="mb-3 mr-2"
                                                                margin="dense"
                                                                label="Year 3"
                                                                type="number"
                                                                value={settings.funeral_year3_executive_agent_rate}
                                                                onChange={(e) => {
                                                                    setSettings((prevSettings) => ({
                                                                        ...prevSettings,
                                                                        funeral_year3_executive_agent_rate: parseFloat(e.target.value)
                                                                    }))
                                                                }
                                                                }
                                                            />
                                                            <TextField
                                                                className="mb-3 mr-2"
                                                                margin="dense"
                                                                label="Year 4"
                                                                type="number"
                                                                value={settings.funeral_year4_executive_agent_rate}
                                                                onChange={(e) => {
                                                                    setSettings((prevSettings) => ({
                                                                        ...prevSettings,
                                                                        funeral_year4_executive_agent_rate: parseFloat(e.target.value)
                                                                    }))
                                                                }
                                                                }
                                                            />
                                                            <TextField
                                                                className="mb-3"
                                                                margin="dense"
                                                                label="Year 5"
                                                                type="number"
                                                                value={settings.funeral_year5_executive_agent_rate}
                                                                onChange={(e) => {
                                                                    setSettings((prevSettings) => ({
                                                                        ...prevSettings,
                                                                        funeral_year5_executive_agent_rate: parseFloat(e.target.value)
                                                                    }))
                                                                }
                                                                }
                                                            />
                                                        </div>
                                                        <div className={clsx(classes.smallColumn, classes.helper)}>
                                                            <Button
                                                                onClick={updateSettings}
                                                                className="btn btn-round btn-primary">
                                                                &nbsp;Update Rates&nbsp;
                                                                <i className="fa fa-check-double"/>
                                                            </Button>
                                                        </div>
                                                    </AccordionDetails>
                                                    <Divider/>

                                                </Accordion>
                                                <Accordion>
                                                    <AccordionSummary
                                                        expandIcon={<ExpandMoreIcon/>}
                                                        aria-controls="panel1c-content"
                                                        id="panel1c-header"
                                                    >
                                                        <div className={classes.bigColumn}>
                                                            <Typography
                                                                className={classes.heading}>Funeral
                                                                Unit Leader</Typography>
                                                        </div>

                                                        <div className={classes.smallColumn}>
                                                            <Typography
                                                                className={classes.secondaryHeading}>Manage</Typography>
                                                        </div>
                                                    </AccordionSummary>
                                                    <AccordionDetails className={classes.details}>

                                                        <div className={classes.bigColumn}>

                                                            <TextField
                                                                className="mb-3 mr-2"
                                                                margin="dense"
                                                                label="Year 1"
                                                                type="number"
                                                                value={settings.funeral_year1_unit_leader_agent_rate}
                                                                onChange={(e) => {
                                                                    setSettings((prevSettings) => ({
                                                                        ...prevSettings,
                                                                        funeral_year1_unit_leader_agent_rate: parseFloat(e.target.value)
                                                                    }))
                                                                }
                                                                }
                                                            />
                                                            <TextField
                                                                className="mb-3 mr-2"
                                                                margin="dense"
                                                                label="Year 2"
                                                                type="number"
                                                                value={settings.funeral_year2_unit_leader_agent_rate}
                                                                onChange={(e) => {
                                                                    setSettings((prevSettings) => ({
                                                                        ...prevSettings,
                                                                        funeral_year2_unit_leader_agent_rate: parseFloat(e.target.value)
                                                                    }))
                                                                }
                                                                }
                                                            />
                                                            <TextField
                                                                className="mb-3 mr-2"
                                                                margin="dense"
                                                                label="Year 3"
                                                                type="number"
                                                                value={settings.funeral_year3_unit_leader_agent_rate}
                                                                onChange={(e) => {
                                                                    setSettings((prevSettings) => ({
                                                                        ...prevSettings,
                                                                        funeral_year3_unit_leader_agent_rate: parseFloat(e.target.value)
                                                                    }))
                                                                }
                                                                }
                                                            />
                                                            <TextField
                                                                className="mb-3 mr-2"
                                                                margin="dense"
                                                                label="Year 4"
                                                                type="number"
                                                                value={settings.funeral_year4_unit_leader_agent_rate}
                                                                onChange={(e) => {
                                                                    setSettings((prevSettings) => ({
                                                                        ...prevSettings,
                                                                        funeral_year4_unit_leader_agent_rate: parseFloat(e.target.value)
                                                                    }))
                                                                }
                                                                }
                                                            />
                                                            <TextField
                                                                className="mb-3"
                                                                margin="dense"
                                                                label="Year 5"
                                                                type="number"
                                                                value={settings.funeral_year5_unit_leader_agent_rate}
                                                                onChange={(e) => {
                                                                    setSettings((prevSettings) => ({
                                                                        ...prevSettings,
                                                                        funeral_year5_unit_leader_agent_rate: parseFloat(e.target.value)
                                                                    }))
                                                                }
                                                                }
                                                            />
                                                        </div>
                                                        <div className={clsx(classes.smallColumn, classes.helper)}>
                                                            <Button
                                                                onClick={updateSettings}
                                                                className="btn btn-round btn-primary">
                                                                &nbsp;Update Rates&nbsp;
                                                                <i className="fa fa-check-double"/>
                                                            </Button>
                                                        </div>
                                                    </AccordionDetails>
                                                    <Divider/>

                                                </Accordion>
                                                <Accordion>
                                                    <AccordionSummary
                                                        expandIcon={<ExpandMoreIcon/>}
                                                        aria-controls="panel1c-content"
                                                        id="panel1c-header"
                                                    >
                                                        <div className={classes.bigColumn}>
                                                            <Typography
                                                                className={classes.heading}>Comprehensive
                                                                Tied</Typography>
                                                        </div>

                                                        <div className={classes.smallColumn}>
                                                            <Typography
                                                                className={classes.secondaryHeading}>Manage</Typography>
                                                        </div>
                                                    </AccordionSummary>
                                                    <AccordionDetails className={classes.details}>

                                                        <div className={classes.bigColumn}>

                                                            <TextField
                                                                className="mb-3 mr-2"
                                                                margin="dense"
                                                                label="Year 1"
                                                                type="number"
                                                                value={settings.comprehensive_year1_tied_agent_rate}
                                                                onChange={(e) => {
                                                                    setSettings((prevSettings) => ({
                                                                        ...prevSettings,
                                                                        comprehensive_year1_tied_agent_rate: parseFloat(e.target.value)
                                                                    }))
                                                                }
                                                                }
                                                            />
                                                            <TextField
                                                                className="mb-3 mr-2"
                                                                margin="dense"
                                                                label="Year 2"
                                                                type="number"
                                                                value={settings.comprehensive_year2_tied_agent_rate}
                                                                onChange={(e) => {
                                                                    setSettings((prevSettings) => ({
                                                                        ...prevSettings,
                                                                        comprehensive_year2_tied_agent_rate: parseFloat(e.target.value)
                                                                    }))
                                                                }
                                                                }
                                                            />
                                                            <TextField
                                                                className="mb-3 mr-2"
                                                                margin="dense"
                                                                label="Year 3"
                                                                type="number"
                                                                value={settings.comprehensive_year3_tied_agent_rate}
                                                                onChange={(e) => {
                                                                    setSettings((prevSettings) => ({
                                                                        ...prevSettings,
                                                                        comprehensive_year3_tied_agent_rate: parseFloat(e.target.value)
                                                                    }))
                                                                }
                                                                }
                                                            />
                                                        </div>
                                                        <div className={clsx(classes.smallColumn, classes.helper)}>
                                                            <Button
                                                                onClick={updateSettings}
                                                                className="btn btn-round btn-primary">
                                                                &nbsp;Update Rates&nbsp;
                                                                <i className="fa fa-check-double"/>
                                                            </Button>
                                                        </div>
                                                    </AccordionDetails>
                                                    <Divider/>

                                                </Accordion>
                                                <Accordion>
                                                    <AccordionSummary
                                                        expandIcon={<ExpandMoreIcon/>}
                                                        aria-controls="panel1c-content"
                                                        id="panel1c-header"
                                                    >
                                                        <div className={classes.bigColumn}>
                                                            <Typography
                                                                className={classes.heading}>Comprehensive
                                                                Executive</Typography>
                                                        </div>

                                                        <div className={classes.smallColumn}>
                                                            <Typography
                                                                className={classes.secondaryHeading}>Manage</Typography>
                                                        </div>
                                                    </AccordionSummary>
                                                    <AccordionDetails className={classes.details}>

                                                        <div className={classes.bigColumn}>

                                                            <TextField
                                                                className="mb-3 mr-2"
                                                                margin="dense"
                                                                label="Year 1"
                                                                type="number"
                                                                value={settings.comprehensive_year1_executive_agent_rate}
                                                                onChange={(e) => {
                                                                    setSettings((prevSettings) => ({
                                                                        ...prevSettings,
                                                                        comprehensive_year1_executive_agent_rate: parseFloat(e.target.value)
                                                                    }))
                                                                }
                                                                }
                                                            />
                                                            <TextField
                                                                className="mb-3 mr-2"
                                                                margin="dense"
                                                                label="Year 2"
                                                                type="number"
                                                                value={settings.comprehensive_year2_executive_agent_rate}
                                                                onChange={(e) => {
                                                                    setSettings((prevSettings) => ({
                                                                        ...prevSettings,
                                                                        comprehensive_year2_executive_agent_rate: parseFloat(e.target.value)
                                                                    }))
                                                                }
                                                                }
                                                            />
                                                            <TextField
                                                                className="mb-3 mr-2"
                                                                margin="dense"
                                                                label="Year 3"
                                                                type="number"
                                                                value={settings.comprehensive_year3_executive_agent_rate}
                                                                onChange={(e) => {
                                                                    setSettings((prevSettings) => ({
                                                                        ...prevSettings,
                                                                        comprehensive_year3_executive_agent_rate: parseFloat(e.target.value)
                                                                    }))
                                                                }
                                                                }
                                                            />
                                                        </div>
                                                        <div className={clsx(classes.smallColumn, classes.helper)}>
                                                            <Button
                                                                onClick={updateSettings}
                                                                className="btn btn-round btn-primary">
                                                                &nbsp;Update Rates&nbsp;
                                                                <i className="fa fa-check-double"/>
                                                            </Button>
                                                        </div>
                                                    </AccordionDetails>
                                                    <Divider/>

                                                </Accordion>
                                                <Accordion>
                                                    <AccordionSummary
                                                        expandIcon={<ExpandMoreIcon/>}
                                                        aria-controls="panel1c-content"
                                                        id="panel1c-header"
                                                    >
                                                        <div className={classes.bigColumn}>
                                                            <Typography
                                                                className={classes.heading}>Comprehensive
                                                                Unit Leader</Typography>
                                                        </div>

                                                        <div className={classes.smallColumn}>
                                                            <Typography
                                                                className={classes.secondaryHeading}>Manage</Typography>
                                                        </div>
                                                    </AccordionSummary>
                                                    <AccordionDetails className={classes.details}>

                                                        <div className={classes.bigColumn}>

                                                            <TextField
                                                                className="mb-3 mr-2"
                                                                margin="dense"
                                                                label="Year 1"
                                                                type="number"
                                                                value={settings.comprehensive_year1_unit_leader_agent_rate}
                                                                onChange={(e) => {
                                                                    setSettings((prevSettings) => ({
                                                                        ...prevSettings,
                                                                        comprehensive_year1_unit_leader_agent_rate: parseFloat(e.target.value)
                                                                    }))
                                                                }
                                                                }
                                                            />
                                                            <TextField
                                                                className="mb-3 mr-2"
                                                                margin="dense"
                                                                label="Year 2"
                                                                type="number"
                                                                value={settings.comprehensive_year2_unit_leader_agent_rate}
                                                                onChange={(e) => {
                                                                    setSettings((prevSettings) => ({
                                                                        ...prevSettings,
                                                                        comprehensive_year2_unit_leader_agent_rate: parseFloat(e.target.value)
                                                                    }))
                                                                }
                                                                }
                                                            />
                                                            <TextField
                                                                className="mb-3 mr-2"
                                                                margin="dense"
                                                                label="Year 3"
                                                                type="number"
                                                                value={settings.comprehensive_year3_unit_leader_agent_rate}
                                                                onChange={(e) => {
                                                                    setSettings((prevSettings) => ({
                                                                        ...prevSettings,
                                                                        comprehensive_year3_unit_leader_agent_rate: parseFloat(e.target.value)
                                                                    }))
                                                                }
                                                                }
                                                            />
                                                        </div>
                                                        <div className={clsx(classes.smallColumn, classes.helper)}>
                                                            <Button
                                                                onClick={updateSettings}
                                                                className="btn btn-round btn-primary">
                                                                &nbsp;Update Rates&nbsp;
                                                                <i className="fa fa-check-double"/>
                                                            </Button>
                                                        </div>
                                                    </AccordionDetails>
                                                    <Divider/>

                                                </Accordion>
                                                <Accordion>
                                                    <AccordionSummary
                                                        expandIcon={<ExpandMoreIcon/>}
                                                        aria-controls="panel1c-content"
                                                        id="panel1c-header"
                                                    >
                                                        <div className={classes.bigColumn}>
                                                            <Typography
                                                                className={classes.heading}>Savings Tied</Typography>
                                                        </div>

                                                        <div className={classes.smallColumn}>
                                                            <Typography
                                                                className={classes.secondaryHeading}>Manage</Typography>
                                                        </div>
                                                    </AccordionSummary>
                                                    <AccordionDetails className={classes.details}>
                                                        <div className={classes.bigColumn}>

                                                            <TextField
                                                                className="mb-3 mr-2"
                                                                margin="dense"
                                                                label="Year 1"
                                                                type="number"
                                                                value={settings.savings_year1_tied_agent_rate}
                                                                onChange={(e) => {
                                                                    setSettings((prevSettings) => ({
                                                                        ...prevSettings,
                                                                        savings_year1_tied_agent_rate: parseFloat(e.target.value)
                                                                    }))
                                                                }
                                                                }
                                                            />

                                                        </div>
                                                        <div className={clsx(classes.smallColumn, classes.helper)}>
                                                            <Button
                                                                onClick={updateSettings}
                                                                className="btn btn-round btn-primary">
                                                                &nbsp;Update Rates&nbsp;
                                                                <i className="fa fa-check-double"/>
                                                            </Button>
                                                        </div>
                                                    </AccordionDetails>
                                                    <Divider/>

                                                </Accordion>
                                                <Accordion>
                                                    <AccordionSummary
                                                        expandIcon={<ExpandMoreIcon/>}
                                                        aria-controls="panel1c-content"
                                                        id="panel1c-header"
                                                    >
                                                        <div className={classes.bigColumn}>
                                                            <Typography
                                                                className={classes.heading}>Savings
                                                                Executive</Typography>
                                                        </div>

                                                        <div className={classes.smallColumn}>
                                                            <Typography
                                                                className={classes.secondaryHeading}>Manage</Typography>
                                                        </div>
                                                    </AccordionSummary>
                                                    <AccordionDetails className={classes.details}>
                                                        {/*<div className={classes.smallColumn}/>*/}
                                                        <div className={classes.bigColumn}>

                                                            <TextField
                                                                className="mb-3 mr-2"
                                                                margin="dense"
                                                                label="Year 1"
                                                                type="number"
                                                                value={settings.savings_year1_executive_agent_rate}
                                                                onChange={(e) => {
                                                                    setSettings((prevSettings) => ({
                                                                        ...prevSettings,
                                                                        savings_year1_executive_agent_rate: parseFloat(e.target.value)
                                                                    }))
                                                                }
                                                                }
                                                            />

                                                        </div>
                                                        <div className={clsx(classes.smallColumn, classes.helper)}>
                                                            <Button
                                                                onClick={updateSettings}
                                                                className="btn btn-round btn-primary">
                                                                &nbsp;Update Rates&nbsp;
                                                                <i className="fa fa-check-double"/>
                                                            </Button>
                                                        </div>
                                                    </AccordionDetails>
                                                    <Divider/>

                                                </Accordion>
                                                <Accordion>
                                                    <AccordionSummary
                                                        expandIcon={<ExpandMoreIcon/>}
                                                        aria-controls="panel1c-content"
                                                        id="panel1c-header"
                                                    >
                                                        <div className={classes.bigColumn}>
                                                            <Typography
                                                                className={classes.heading}>Savings
                                                                Unit Leader</Typography>
                                                        </div>

                                                        <div className={classes.smallColumn}>
                                                            <Typography
                                                                className={classes.secondaryHeading}>Manage</Typography>
                                                        </div>
                                                    </AccordionSummary>
                                                    <AccordionDetails className={classes.details}>
                                                        <div className={classes.bigColumn}>

                                                            <TextField
                                                                className="mb-3 mr-2"
                                                                margin="dense"
                                                                label="Year 1"
                                                                type="number"
                                                                value={settings.savings_year1_unit_leader_agent_rate}
                                                                onChange={(e) => {
                                                                    setSettings((prevSettings) => ({
                                                                        ...prevSettings,
                                                                        savings_year1_unit_leader_agent_rate: parseFloat(e.target.value)
                                                                    }))
                                                                }
                                                                }
                                                            />

                                                        </div>
                                                        <div className={clsx(classes.smallColumn, classes.helper)}>
                                                            <Button
                                                                onClick={updateSettings}
                                                                className="btn btn-round btn-primary">
                                                                &nbsp;Update Rates&nbsp;
                                                                <i className="fa fa-check-double"/>
                                                            </Button>
                                                        </div>
                                                    </AccordionDetails>
                                                    <Divider/>

                                                </Accordion>
                                                <Accordion>
                                                    <AccordionSummary
                                                        expandIcon={<ExpandMoreIcon/>}
                                                        aria-controls="panel1c-content"
                                                        id="panel1c-header"
                                                    >
                                                        <div className={classes.bigColumn}>
                                                            <Typography
                                                                className={classes.heading}>Pfuma / Inotho
                                                                Agent</Typography>
                                                        </div>

                                                        <div className={classes.smallColumn}>
                                                            <Typography
                                                                className={classes.secondaryHeading}>Manage</Typography>
                                                        </div>
                                                    </AccordionSummary>
                                                    <AccordionDetails className={classes.details}>
                                                        <div className={classes.bigColumn}>

                                                            <TextField
                                                                className="mb-3 mr-2"
                                                                margin="dense"
                                                                label="On First Payment"
                                                                type="number"
                                                                value={settings.pfumaInoto_sales_agent_rate}
                                                                onChange={(e) => {
                                                                    setSettings((prevSettings) => ({
                                                                        ...prevSettings,
                                                                        pfumaInoto_sales_agent_rate: parseFloat(e.target.value)
                                                                    }))
                                                                }
                                                                }
                                                            />

                                                        </div>
                                                        <div className={clsx(classes.smallColumn, classes.helper)}>
                                                            <Button
                                                                onClick={updateSettings}
                                                                className="btn btn-round btn-primary">
                                                                &nbsp;Update Rates&nbsp;
                                                                <i className="fa fa-check-double"/>
                                                            </Button>
                                                        </div>
                                                    </AccordionDetails>
                                                    <Divider/>

                                                </Accordion>
                                                <Accordion>
                                                    <AccordionSummary
                                                        expandIcon={<ExpandMoreIcon/>}
                                                        aria-controls="panel1c-content"
                                                        id="panel1c-header"
                                                    >
                                                        <div className={classes.bigColumn}>
                                                            <Typography
                                                                className={classes.heading}>Pfuma / Inotho
                                                                CDA</Typography>
                                                        </div>

                                                        <div className={classes.smallColumn}>
                                                            <Typography
                                                                className={classes.secondaryHeading}>Manage</Typography>
                                                        </div>
                                                    </AccordionSummary>
                                                    <AccordionDetails className={classes.details}>
                                                        <div className={classes.bigColumn}>

                                                            <TextField
                                                                className="mb-3 mr-2"
                                                                margin="dense"
                                                                label="Year 1"
                                                                type="number"
                                                                value={settings.pfumaInoto_CDA_agent_rate}
                                                                onChange={(e) => {
                                                                    setSettings((prevSettings) => ({
                                                                        ...prevSettings,
                                                                        pfumaInoto_CDA_agent_rate: parseFloat(e.target.value)
                                                                    }))
                                                                }
                                                                }
                                                            />

                                                        </div>
                                                        <div className={clsx(classes.smallColumn, classes.helper)}>
                                                            <Button
                                                                onClick={updateSettings}
                                                                className="btn btn-round btn-primary">
                                                                &nbsp;Update Rates&nbsp;
                                                                <i className="fa fa-check-double"/>
                                                            </Button>
                                                        </div>
                                                    </AccordionDetails>
                                                    <Divider/>

                                                </Accordion>
                                            </div>
                                        </>

                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Index;
